import { Link } from '@tanstack/react-router';
import { CalendarDays } from 'lucide-react';

import type { HomeNextSession } from '@/lib/api/home';

function fmt(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  if (d.toDateString() === today.toDateString()) return `Today, ${time}`;
  if (d.toDateString() === tomorrow.toDateString()) return `Tomorrow, ${time}`;
  return `${d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}, ${time}`;
}

export function UpcomingSessionCard({ session }: { session: HomeNextSession | null }) {
  return (
    <div className="flex items-center gap-4 rounded-[20px] border border-[#ececec] bg-white px-[21px] py-[17px] shadow-[0px_1px_4px_rgba(0,0,0,0.04)]">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[#ede9fe]">
        <CalendarDays className="size-5 text-[#8b5cf6]" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-semibold leading-[19.5px] text-[#6b7280]">Upcoming Live Session</p>
        {session && session.scheduled_at ? (
          <>
            <p className="truncate text-[15px] font-bold leading-[22.5px] text-[#111827]">{session.title || 'Live Session'}</p>
            <p className="pt-0.5 text-xs text-[#9ca3af]">{fmt(session.scheduled_at)}</p>
          </>
        ) : (
          <p className="pt-0.5 text-xs text-[#9ca3af]">No upcoming session</p>
        )}
      </div>
      {session && session.scheduled_at && (
        <Link to="/schedule" className="shrink-0 rounded-[14px] bg-[#ede9fe] px-[14px] py-2 text-xs font-semibold text-[#8b5cf6]">
          View in Calendar
        </Link>
      )}
    </div>
  );
}
